import { createSlice } from "@reduxjs/toolkit";

try {
  localStorage.removeItem("siteConfig");
} catch {
  // Tracking configuration is session-scoped and remains available in memory.
}

const initialState = {
  config: {},
};

const configSlice = createSlice({
  name: "config",
  initialState,
  reducers: {
    setConfig: (state, action) => {
      state.config = action.payload;
    },
  },
});

export const { setConfig } = configSlice.actions;

export default configSlice.reducer;
